import { gql } from "@apollo/client";
export const SAS_TOKEN = gql`
  query SASToken {
    sasToken
  }
`;
